import { LanguageType } from 'src/metronic/core/_config/i18n/language-type.model';

export const isPolishLanguage = (language: string | LanguageType) =>
language === LanguageType.Polish || language.startsWith(LanguageType.Polish);
